import React from 'react';

function Button({ variant = 'primary', children, iconRight, iconLeft, href, className = '', ...props }) {
  const classNames = `btn btn-${variant}${className ? ' ' + className : ''}`;
  const content = (
    <>
      {iconLeft && <i className={iconLeft} aria-hidden="true" />}
      {children}
      {iconRight && <i className={iconRight} aria-hidden="true" />}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classNames} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classNames} {...props}>
      {content}
    </button>
  );
}

export default Button;
